import databaseInstance from "api";

const dbInstance: any = databaseInstance;

export const getCommunity = async (params: any) => {
    const { queryKey } = params;
    const [, communitySlug] = queryKey;

    if (!communitySlug) {
        throw new Error("Community Id Unavailable");
    }

    try {
        const response: any = await dbInstance.get(`/groups/${communitySlug}?include=channels:30,plans`);
        return response.data;
    } catch (error) {
        console.error(error);
        throw new Error((error as any).message);
    }
}

export const fetchCoursesSections = async (groupId: any, courseId: any) => {
    if (courseId === undefined) {
        throw new Error("Course Id Unavailable");
    }
    try {
        const response: any = await dbInstance.get(`/groups/${groupId}/courses/${courseId}/admin-sections`);
        return response.data;
    } catch (error) {
        console.error(error);
        throw new Error((error as any).message);
    }
}


export const fetchSectionContent = async (courseId: number, sectionId: number) => {

    try {
        const response: any = await dbInstance.get(`/courses/${courseId}/sections/${sectionId}/contents?admin=true`);
        return response.data;
    } catch (error) {
        console.error(error);
        throw new Error((error as any).message);
    }
}

export const fetchCourseEnrollments = async (courseId: number, query?: string) => {

    try {
        const response: any = await dbInstance.get(`/courses/${courseId}/enrolments?nsearch=${query}`);
        return response.data;
    } catch (error) {
        console.error(error);
        new Error((error as any).message);
        new Error("Something went wrong!")
    }
}

export const fetchFlaggedContent = async (groupId: number) => {
    try {
        const response: any = await dbInstance.get(`/groups/${groupId}/flagged-contents`);
        return response.data;
    } catch (error) {
        console.error(error);
        new Error((error as any).message);
        new Error("Something went wrong!")
    }
}

export const fetchPostsToModerate = async (groupId: number) => {
    try {
        const response: any = await dbInstance.get(`/groups/${groupId}/moderated-posts`);
        return response.data;
    } catch (error) {
        console.error(error);
        new Error((error as any).message);
        new Error("Something went wrong!")
    }
}

export const fetchMembershipRequests = async (groupId: number, query: string = '') => {
    try {
        const response: any = await dbInstance.get(`/groups/${groupId}/membership-requests?search=${query}`);
        return response.data;
    } catch (error) {
        console.error(error);
        new Error((error as any).message);
        new Error("Something went wrong!")
    }
}

export const fetchCoursesList = async (courseId: any) => {

    try {
        const response: any = await dbInstance.get(`/courses/${courseId}/sections`);
        return response.data;
    } catch (error) {
        console.error(error);
        new Error((error as any).message);
        new Error("Something went wrong!")
    }
}

export const fetchGroupMembers = async (
    groupId: number,
    query?: string,
    page?: number
) => {

    let url = `/groups/${groupId}/memberships`;

    // collect query parts
    const queryParts: string[] = [];

    if (query && query.length > 0) {
        queryParts.push(`search=${encodeURIComponent(query)}`);
    }

    if (page) {
        queryParts.push(`page=${page}`);
    }

    // append if we have any query params
    if (queryParts.length > 0) {
        url += `?${queryParts.join("&")}`;
    }

    try {
        const response: any = await dbInstance.get(url);
        if (response && response.data) {
            return response;
        }
    } catch (error) {
        console.error(error);
        throw new Error((error as any).message);
    }
}

export const fetchAllLibContents = async (
    groupId: number,
    type: string,
    page: number,
    published?: boolean,
    has_category?: boolean,
    community?: boolean,
) => {

    try {
        const response: any = await dbInstance.get(`/groups/${groupId}/library-contents?page=${page}${published !== undefined ? `&published=${published}` : ''}${type.length > 0 ? `&type=${type}` : ''}${has_category !== undefined ? `&has_category=${has_category}` : ""}${community ? '&community=true' : ''}`);
        return response.data;
    } catch (error) {
        console.error(error);
        new Error((error as any).message);
        new Error("Something went wrong!")
    }
}

export const fetchMyLibContents = async (
    userId: number,
    groupId: number,
    type: string,
    page: number,
    has_category?: boolean,
) => {

    try {
        const response: any = await dbInstance.get(`/users/${userId}/groups/${groupId}/library-contents?${type.length > 0 ? `type=${type}` : ''}&page=${page}${has_category !== undefined ? `&has_category=${has_category}` : ""}`);
        return response.data;
    } catch (error) {
        console.error(error);
        new Error((error as any).message);
        new Error("Something went wrong!")
    }
}

export const fetchCustomProfileFields = async (
    groupId: number,
) => {

    try {
        const response: any = await dbInstance.get(`/groups/${groupId}/community-fields?category=custom`);
        return response.data;
    } catch (error) {
        console.error(error);
        new Error((error as any).message);
        new Error("Something went wrong!")
    }
}